// Lightweight markdown renderer for chat / RCA — supports headings, lists, code, bold, italics, links.
import { useMemo } from "react";

function escapeHtml(s) {
  return s.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
}

function renderInline(text) {
  let t = escapeHtml(text);
  t = t.replace(/`([^`]+)`/g, "<code>$1</code>");
  t = t.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
  t = t.replace(/\*([^*]+)\*/g, "<em>$1</em>");
  t = t.replace(/\[([^\]]+)\]\((https?:[^)]+)\)/g, '<a href="$2" target="_blank" rel="noreferrer">$1</a>');
  return t;
}

function toHtml(md) {
  const lines = (md || "").split("\n");
  let out = "";
  let inCode = false;
  let codeBuf = [];
  let listType = null; // ul|ol
  const flushList = () => { if (listType) { out += `</${listType}>`; listType = null; } };
  for (let i = 0; i < lines.length; i++) {
    const raw = lines[i];
    if (raw.startsWith("```")) {
      if (inCode) { out += `<pre><code>${escapeHtml(codeBuf.join("\n"))}</code></pre>`; codeBuf = []; inCode = false; }
      else { flushList(); inCode = true; }
      continue;
    }
    if (inCode) { codeBuf.push(raw); continue; }
    const line = raw.trimEnd();
    if (!line.trim()) { flushList(); out += ""; continue; }
    if (/^#{1,3}\s+/.test(line)) {
      flushList();
      const level = line.match(/^#+/)[0].length;
      out += `<h${level}>${renderInline(line.replace(/^#+\s+/, ""))}</h${level}>`;
      continue;
    }
    if (/^[-*]\s+/.test(line)) {
      if (listType !== "ul") { flushList(); out += "<ul>"; listType = "ul"; }
      out += `<li>${renderInline(line.replace(/^[-*]\s+/, ""))}</li>`;
      continue;
    }
    if (/^\d+\.\s+/.test(line)) {
      if (listType !== "ol") { flushList(); out += "<ol>"; listType = "ol"; }
      out += `<li>${renderInline(line.replace(/^\d+\.\s+/, ""))}</li>`;
      continue;
    }
    flushList();
    out += `<p>${renderInline(line)}</p>`;
  }
  flushList();
  if (inCode) out += `<pre><code>${escapeHtml(codeBuf.join("\n"))}</code></pre>`;
  return out;
}

export default function Markdown({ source = "", className = "" }) {
  const html = useMemo(() => toHtml(source), [source]);
  return <div className={`md ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
}
